import moment, {Moment} from "moment";
import {TYMD} from "./common";

export class FrontDate {

    public static fromNew(): FrontDate {
        const fromDate: Moment = moment();
        const year = fromDate.year().toString();
        const month = ("00" + (fromDate.month() + 1 ).toString()).slice(-2);
        const day = ("00" + fromDate.date().toString()).slice(-2);
        const from = year + '-' + month + '-' + day;

        return new FrontDate(
            year,
            month,
            day,
            from,
        )
    }

    // 空のFrontDateを制作する
    public static fromEmpty(): FrontDate {

        const year: string = "";
        const month: string = "";
        const day: string = "";

        return new FrontDate(
            year,
            month,
            day,
            "",
        )
    }

    public static from(from: string): FrontDate {

        let year: string = "";
        let month: string = "";
        let day: string = "";

        // "0001-01-01 09:00:00"はバックエンド初期値（空白値）
        // ""の場合も空白値
        if (from !== "0001-01-01 09:00:00" && from !=="") {
            const fromDate: Moment = moment(from, "YYYY-MM-DD HH:II:SS");
            year = fromDate.year().toString();
            month = ("00" + (fromDate.month() + 1 ).toString()).slice(-2);
            day = ("00" + fromDate.date().toString()).slice(-2);
        }

        return new FrontDate(
            year,
            month,
            day,
            from,
        )

    }

    public static fromYearMonthDayNumber(fromYear: number, fromMonth: number, fromDay: number): FrontDate {

        let year: string = "";
        let month: string = "";
        let day: string = "";

        // fromはないが他と合わせるためにつくっていれている　空白のままのほうがいいかもしれない
        let from = "";

        // "0001-01-01 09:00:00"はバックエンド初期値（空白値）
        if (!(fromYear === 1 && fromMonth === 1 && fromDay === 1)) {
            // 0は不明値
            year = fromYear === 0 ? "" : ("0000" + fromYear).slice(-4);
            month = fromMonth === 0 ? "" : ("00" + fromMonth).slice(-2);
            day = fromDay === 0 ? "" : ("00" + fromDay).slice(-2);
            from = year + '-' + month + '-' + day;
        }

        return new FrontDate(
            year,
            month,
            day,
            from,
        )

    }

    // yyyy-mm のquerystringからの変換
    public static fromQueryString(from: string): FrontDate {

        let year: string = "";
        let month: string = "";
        let day: string = "";

        // 空文字の場合は変換しない
        if (from !== "") {
            const fromDate: Moment = moment(from, "YYYY-MM");
            //    値チェック 変換後にNanがあるなら空白値
            if (Number.isNaN(Number(fromDate.year())) || Number.isNaN(Number(fromDate.month())) || Number.isNaN(Number(fromDate.date()))) {
                return new FrontDate(
                    year,
                    month,
                    day,
                    from,
                )
            }
            year = fromDate.year().toString();
            month = ("00" + (fromDate.month() + 1 ).toString()).slice(-2);
            day = ("00" + fromDate.date().toString()).slice(-2);
        }

        return new FrontDate(
            year,
            month,
            day,
            from,
        )

    }

    public static fromYMD (ymd?: TYMD | null): FrontDate {
        let year: string = "";
        let month: string = "";
        let day: string = "";

        // fromはないが他と合わせるためにつくっていれている　空白のままのほうがいいかもしれない
        let from = "";

        if (ymd) {
            // 0は不明値
            year = ymd.year === 0 ? "" : ("0000" + ymd.year).slice(-4);
            month = ymd.month === 0 ? "" : ("00" + ymd.month).slice(-2);
            day = ymd.day === 0 ? "" : ("00" + ymd.day).slice(-2);
            from = year + '-' + month + '-' + day;
        }

        return new FrontDate(
            year,
            month,
            day,
            from,
        )
    }

    constructor(public readonly year: string,
                public readonly month: string,
                public readonly day: string,
                public readonly originValue: string,

    ) {}


}




// WEBPACK FOOTER //
// ./src/domain/model/frontDate.ts